export default __webpack_public_path__ + "static/media/36-37.ba1548ef.png";